import { render, staticRenderFns } from "./FoxCoinAddLabel.vue?vue&type=template&id=0df44f50&scoped=true&"
import script from "./FoxCoinAddLabel.vue?vue&type=script&lang=js&"
export * from "./FoxCoinAddLabel.vue?vue&type=script&lang=js&"
import style0 from "./FoxCoinAddLabel.vue?vue&type=style&index=0&id=0df44f50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df44f50",
  null
  
)

export default component.exports